module.exports = __webpack_public_path__ + "media/images/vp/sample.shishkin-14b596475fd82d9849c84d0f20f78923.jpg";